/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindInformationRequestsByGroupQueryResponse,
  FindInformationRequestsByGroupPathParams,
} from "../types/FindInformationRequestsByGroup.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findInformationRequestsByGroupQueryKey = (
  groupId: FindInformationRequestsByGroupPathParams["groupId"] | undefined
) =>
  [
    {
      url: "/v1/traceability-requests/groups/:groupId/members",
      params: { groupId: groupId },
    },
  ] as const

export type FindInformationRequestsByGroupQueryKey = ReturnType<
  typeof findInformationRequestsByGroupQueryKey
>

/**
 * @summary Find information requests by group
 * {@link /v1/traceability-requests/groups/:groupId/members}
 */
export async function findInformationRequestsByGroup(
  groupId: FindInformationRequestsByGroupPathParams["groupId"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindInformationRequestsByGroupQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests/groups/${groupId}/members`,
    ...requestConfig,
  })
  return res
}

export function findInformationRequestsByGroupQueryOptions(
  groupId: FindInformationRequestsByGroupPathParams["groupId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findInformationRequestsByGroupQueryKey(groupId)
  return queryOptions<
    ResponseConfig<FindInformationRequestsByGroupQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindInformationRequestsByGroupQueryResponse>,
    typeof queryKey
  >({
    enabled: !!groupId,
    queryKey,
    queryFn: async ({ signal }) => {
      return findInformationRequestsByGroup(groupId!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find information requests by group
 * {@link /v1/traceability-requests/groups/:groupId/members}
 */
export function useFindInformationRequestsByGroup<
  TData = ResponseConfig<FindInformationRequestsByGroupQueryResponse>,
  TQueryData = ResponseConfig<FindInformationRequestsByGroupQueryResponse>,
  TQueryKey extends QueryKey = FindInformationRequestsByGroupQueryKey,
>(
  groupId: FindInformationRequestsByGroupPathParams["groupId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindInformationRequestsByGroupQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findInformationRequestsByGroupQueryKey(groupId)

  const query = useQuery(
    {
      ...findInformationRequestsByGroupQueryOptions(groupId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
